var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "router-link",
        {
          staticClass: "btn btn-link",
          attrs: { to: { name: "qa-link" }, target: "_blank" }
        },
        [
          _c("span", [
            _c("a", { attrs: { href: _vm.qaLinkUrl(), target: "_blank" } }, [
              _vm._v(_vm._s(_vm.$t("QaLink")))
            ])
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "sr-only" }, [
            _vm._v(_vm._s(_vm.$t("NewWindow")))
          ]),
          _vm._v(" "),
          _c("i", { staticClass: "fas fa-external-link-alt" })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }